

import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { getLoggedInUserInfo, getOrganizationList } from "Utils/utilityFunctions";
import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { ERROR_MESSAGES } from "Utils/constants";
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import {GetSelectInputObj } from 'Containers/Private/Organization/Data files/OrganizationFields';
import { Form } from "react-bootstrap";


export const OrgList = ({setOrgListData, orgListData, orgList, setOrgList, setOrgListInputDispatch, isListLoading, setIsListLoading, orgListInputDispatch}) => {
    //const [loading,setLoading] = useState(true);
    //const [listData, setListData] = useState([]);
    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',
        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',
        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',
        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',
        CHECK_CHANGE: 'check-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',
        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',
    };

    const errorHandle = function () {
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true, 
                title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                showContactHelp: true 
            },
            redirect: {
                redirect: false, 
                redirectFirst: false,
                path: "", 
                data: {}
            }
        })
    };

    var dispatch = useDispatch();

    /*var [orgList,orgListInputDispatch] = GetSelectInputObj({
        id:"select",
        name:"org",
        value:-1,
        options:[],
        label:"Select an Organization",
        description:"",
        title:"",
        placeholder:"",
        required:true, 
        isInvalid:false,
        errors:[],
        isValid:false,
        successMsgs: [],
        disabled:"",
        readOnly:"",
        hideFieldOrgTypes:""
    });*/
    
    const getOrgListInfo = (errorHandle) => {
        setIsListLoading(true);
        getOrganizationList(errorHandle).then((res) => {
            //console.log(res);
            if(res != null){
                //setListData(res.orgList);
                /*orgListInputDispatch({
                    type: ACTIONS.SET_INITIAL_DATA,
                    options: orgListValues(res.orgList, -1)
                })*/
                setOrgListData(res.orgList);
                //setOrgList(orgList);

                //console.log(res.orgList);
                //console.log(orgList);
                
        
                orgListInputDispatch({
                    type: ACTIONS.SET_INITIAL_DATA,
                    options: orgListValues(res.orgList, -1)
                });
                
                setIsListLoading(false);
                //setOrgList(orgList);

                //setLoading(false);
                return res;
            }
            else{
                //setLoading(false);
                return [];
            }
            
        }); 
    }

    var orgListValues = (orgList, selectedValue) => {
        //console.log(orgList);
        //console.log(selectedValue);
        var objArr = [];
        objArr.push({
            index: 0, 
            value: -1, 
            title: null,
            displayValue: "Select Organization", 
            isSelected: selectedValue==null ? true : false
        });
    
        for (var i = 0; i < orgList.length; i++) {
            var x = orgList[i];

            var idText = "";
            if(x.psoId!=null){
                idText = "(" + x.psoId + ")";
            }
            objArr.push({
                index: x.id, 
                value: x.id, 
                title: "Select organization " + x.name,
                displayValue: x.name + " " + idText, 
                isSelected: selectedValue==x.id ? true : false
            });
        }
    
        return objArr;
    };

    useEffect(() => {
        //console.log(orgListInputDispatch);
        //console.log(orgList);
        //setOrgListInputDispatch(orgListInputDispatch);
        getOrgListInfo(errorHandle);

        

        

    }, []);

    
    var element = () => {
        
    }
            
    const resetSelection = () => { 
        orgListInputDispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: -1
        })
    };
    return(
            <Form>                                
                <FormInputDisplay fieldData={orgList} inputDispatch={orgListInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={{is: false, labelCols: {lg:12}, inputCols: {lg:12}}}></FormInputDisplay>
            </Form>
        );
    return {element: element};
        //dispatch: orgListInputDispatch,
        //list: orgList,
        //resetSelection: resetSelection
    //;
    return(   //loading==false
            //?   
            orgListData!=null ?
                <Form>                                
                    <FormInputDisplay fieldData={orgList} inputDispatch={orgListInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={{is: false, labelCols: {lg:12}, inputCols: {lg:12}}}></FormInputDisplay>
                </Form>

            :   null
    )    ;
            
    
}


//export const {o};
//export const test;